module.exports = __webpack_public_path__ + "static/media/aaronheadshot.480edc23.png";